var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$wait.is("fetching preview resource")
    ? _c("LayoutWithContainer", [
        _c(
          "div",
          { staticClass: "loading" },
          [_c("Spinner", { attrs: { height: 40, width: 40 } })],
          1
        ),
      ])
    : _vm.resource && _vm.resource.children && _vm.resource.children.length > 0
    ? _c(
        "LayoutWithContainer",
        [
          _c(
            "template",
            { slot: "breadcrumbs" },
            [
              !_vm.resource.parent
                ? _c("router-link", { attrs: { to: "/documents" } }, [
                    _vm._v("Back to Documents"),
                  ])
                : _c(
                    "router-link",
                    {
                      attrs: {
                        to: `/documents/category/${_vm.resource.parent.id}`,
                      },
                    },
                    [_vm._v("Back to " + _vm._s(_vm.resource.parent.name))]
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "header" },
            [
              _c(
                "ContentHeader",
                {
                  attrs: {
                    title: _vm.resource.name,
                    "sub-title": _vm.resource.description,
                  },
                },
                [
                  _vm.can("createInsightCategories")
                    ? _c(
                        "template",
                        { slot: "title-extra" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "small-edit",
                              attrs: {
                                to: {
                                  name: "edit-document-category",
                                  params: { category_id: _vm.resource.id },
                                },
                              },
                            },
                            [
                              _c("span", [_vm._v("Edit")]),
                              _vm._v(" "),
                              _c("SvgIcon", {
                                attrs: { icon: "edit", "is-filled": true },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grid grid--cards" },
            _vm._l(_vm.cards, function (card) {
              return _vm.cards && _vm.cards.length
                ? _c(
                    "div",
                    { class: card.colClass },
                    [
                      _c("Card", {
                        key: card.key,
                        attrs: {
                          url: card.url,
                          title: card.title,
                          subTitle: card.subTitle,
                          img: card.img,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e()
            }),
            0
          ),
        ],
        2
      )
    : _vm.resource &&
      (!_vm.resource.children || _vm.resource.children.length === 0)
    ? _c(
        "InsightList",
        {
          attrs: {
            type: _vm.resource.id,
            "page-title": _vm.resource.name,
            "hide-category": true,
            tab: "all",
          },
        },
        [
          _c(
            "template",
            { slot: "back" },
            [
              !_vm.resource.parent
                ? _c("router-link", { attrs: { to: "/documents" } }, [
                    _vm._v("Back to Documents"),
                  ])
                : _c(
                    "router-link",
                    {
                      attrs: {
                        to: `/documents/category/${_vm.resource.parent.id}`,
                      },
                    },
                    [_vm._v("Back to " + _vm._s(_vm.resource.parent.name))]
                  ),
            ],
            1
          ),
        ],
        2
      )
    : _c(
        "LayoutWithContainer",
        [
          _c("span", { staticClass: "h2" }, [_vm._v("An Error Occurred")]),
          _vm._v(" "),
          _c("router-link", { attrs: { to: "/documents" } }, [
            _vm._v("Back to Documents"),
          ]),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }